<div id="safety-app-device-health-configuration" ng-controller="DeviceHealthConfigurationCtrl"></div>